import { createSlice } from '@reduxjs/toolkit';

import { fetch } from './thunks';

import { IEventsStateExtras } from './types';

export const initialState = {
  loading: false,
  events: [],
  error: false,
} as IEventsStateExtras;

export const slice = createSlice({
  name: 'events',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetch.pending, function (state) {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetch.rejected, function (state) {
        state.loading = false;
        state.error = true;
      })
      .addCase(fetch.fulfilled, function (state, action) {
        const events = action.payload;

        state.loading = false;
        state.error = false;
        state.events = events;
      });
  },
});
